import {createContext} from 'react'

const GeneralContext = createContext();

export default GeneralContext;

